/*============================================================================
  #Theme JS
==============================================================================*/

// Theme functions
window.theme = window.theme || {};

theme.init = function () {
  theme.animations();
  theme.hero();
  theme.productCarousel();
  theme.productTabs();
  theme.blog();
  theme.cart();
  theme.retinaImages();
};

theme.animations = function () {
  setTimeout(function () {
    $('.fade-in').addClass('fade-in--active');
  }, 150);
};

theme.hero = function () {
  $('.hero').slick({
    speed: 300,
    autoplay: true,
    autoplaySpeed: 4000,
    pauseOnHover: false,
    fade: true,
    arrows: true,
    dots: false,
    slide: ".hero__slide",
    prevArrow: '<button aria-label="previous image button" type="button" class="slick-prev sm:hidden md:hidden"><span class="icon icon-chevron-left"></span></button>',
    nextArrow: '<button aria-label="next image button" type="button" class="slick-next sm:hidden md:hidden"><span class="icon icon-chevron-right"></span></button>'
  });

  // Loading Bars
  var percentTime;
  var tick;
  var time = 1;
  var progressBarIndex = 0;

  $('.hero__progress-bar-wrap .hero__progress-bar').each(function (index) {
    var progress = "<div class='in-progress in-progress" + index + "'></div>";
    $(this).html(progress);
  });

  function startProgressbar() {
    resetProgressbar();
    percentTime = 0;
    tick = setInterval(interval, 7);
  }

  function interval() {
    if (($('.hero .slick-track div[data-slick-index="' + progressBarIndex + '"]').attr("aria-hidden")) === "true") {
      progressBarIndex = $('.hero .slick-track div[aria-hidden="false"]').data("slickIndex");
      startProgressbar();
    } else {
      percentTime += 1 / (time + 5);
      $('.in-progress' + progressBarIndex).css({
        width: percentTime + "%"
      });
      if (percentTime >= 1000) {
        $('.hero').slick('slickNext');
        progressBarIndex++;
        if (progressBarIndex > 1) {
          progressBarIndex = 0;
        }
        startProgressbar();
      }
    }
  }

  function resetProgressbar() {
    $('.in-progress').css({
      width: 0 + '%'
    });
    clearInterval(tick);
  }
  startProgressbar();

  $('.hero__progress-bar-wrap div').click(function () {
    clearInterval(tick);
    var goToThisIndex = $(this).find("span").data("slickIndex");
    $('.hero').slick('slickGoTo', goToThisIndex, false);
    startProgressbar();
  });
};

theme.productCarousel = function () {
  $('.product-single__carousel').slick({
    speed: 200,
    autoplay: false,
    pauseOnHover: false,
    fade: true,
    arrows: false,
    dots: false,
    focusOnSelect: false,
    prevArrow: '<button aria-label="previous image button" type="button" class="slick-prev floating-button"></button>',
    nextArrow: '<button aria-label="next image button" type="button" class="slick-next floating-button"></button>',
    responsive: [{
      breakpoint: 749,
      settings: {
        arrows: false,
        focusOnSelect: true,
        asNavFor: '.product-single__thumbnails-ct',
      }
    }]
  });

  $('.product-single__thumbnails-ct').slick({
    slidesToShow: 8,
    swipeToSlide: false,
    arrows: false,
    dots: false,
    infinite: false,
    focusOnSelect: false,
    swipe: false,
    asNavFor: '.product-single__carousel',
    prevArrow: '<button aria-label="previous image button" type="button" class="slick-prev thumbnail-nav"></button>',
    nextArrow: '<button aria-label="next image button" type="button" class="slick-next thumbnail-nav"></button>',
    responsive: [{
      breakpoint: 1023,
      settings: {
        slidesToShow: 5,
        focusOnSelect: true,
        swipe: true,
        swipeToSlide: true,
        infinite: false,
      },
      
    }]
  });

  $('.product-single__thumbnails-ct .slick-slide').not('.count-overlay').on('click', function (event) {
    let data = document.querySelector(
      '[segment-product-object]'
    );
    data = JSON.parse(data.innerHTML);

    analytics.track('Image Viewed', {
      "image_position": $(this).data('slickIndex') + 1,
      "action": "viewed",
      "src": event.target.src,
      "context": "PDP",
      "product_id": data.id,
      "url": window.location.href,
      
    });
    $('.product-single__carousel').slick('slickGoTo', $(this).data('slickIndex'));
    $('.product-single__thumbnails-ct .slick-slide').removeClass('slick-current');
    $(this).addClass('slick-current');
 });

 $('.product-single__carousel').on('beforeChange', function(event, slick, currentSlide, nextSlide){
  $('.product-single__thumbnails-ct .slick-slide').removeClass('slick-current');
  $(`.product-single__thumbnails-ct .slick-slide[data-slick-index=${nextSlide}]`).addClass('slick-current');
});


  $('.product-single__carousel--small').slick({
    speed: 150,
    autoplay: false,
    pauseOnHover: false,
    fade: false,
    arrows: true,
    dots: true,
    infinite: true,
    asNavFor: '.product-single__thumbnails--small',
    prevArrow: '<button aria-label="previous image button" type="button" class="slick-prev sm:hidden md:hidden"><span class="icon icon-chevron-left"></span></button>',
    nextArrow: '<button aria-label="next image button" type="button" class="slick-next sm:hidden md:hidden"><span class="icon icon-chevron-right"></span></button>'
  });

  $('.product-single__thumbnails--small').slick({
    speed: 150,
    autoplay: false,
    pauseOnHover: false,
    fade: false,
    arrows: true,
    dots: false,
    vertical: true,
    slidesToShow: 5,
    infinite: true,
    asNavFor: '.product-single__carousel--small',
    focusOnSelect: true,
    prevArrow: '<button aria-label="previous image button" type="button" class="slick-prev"><span class="icon icon-chevron-left"></span></button>',
    nextArrow: '<button aria-label="next image button" type="button" class="slick-next"><span class="icon icon-chevron-right"></span></button>',
    responsive: [{
        breakpoint: 1350,
        settings: {
          slidesToShow: 5,
          slidesToScroll: 1,
          vertical: false
        }
      },
      {
        breakpoint: 1025,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          vertical: false
        }
      }
    ]
  });
};


theme.productTabs = function () {
  $('.mobile-tab').click(function () {
    // If tab is active remove active class
    if ($(this).hasClass('mobile-tab--active')) {
      $(this).removeClass('mobile-tab--active');

      // Collaps content
      var currentTab = '.' + $(this).data('tab');
      $(currentTab).addClass('hide');
    } else {
      // Add active class to current tab
      $('.mobile-tab').removeClass('mobile-tab--active');
      $(this).addClass('mobile-tab--active');

      // Expand content
      var currentTab = '.' + $(this).data('tab');
      $('.tab-content').addClass('hide');
      $(currentTab).removeClass('hide');
    }
  });
};

theme.blog = function () {
  $('.blog__filter-select').change(function () {
    var currentTag = $(this).val();
    if (currentTag == 'tags') {
      e.preventDefault();
    } else if (currentTag == 'all') {
      window.location.href = "/blogs/news";
    } else {
      window.location.href = "/blogs/news/tagged/" + currentTag;
    }
  });
};

theme.cart = function () {
  if ($('body').hasClass('template-cart')) {
    jQuery('[max]').change(function () {
      var max = parseInt(jQuery(this).attr('max'), 10) || 10000;
      var value = parseInt(jQuery(this).val(), 10) || 0;
      if (value > max) {
        jQuery(this).val(max);
      }
      $('#Cart').attr('action', '/cart/update').submit();
    });
  }
}

theme.retinaImages = function () {
  $(window).load(function () {
    /*! Retina.js v2.1.0 */
    ! function () {
      function t(t) {
        return Array.prototype.slice.call(t)
      }

      function e(t) {
        var e = parseInt(t, 10);
        return e > f ? f : e
      }

      function r(t) {
        return t.hasAttribute("data-no-resize") || (0 === t.offsetWidth && 0 === t.offsetHeight ? (t.setAttribute("width", t.naturalWidth), t.setAttribute("height", t.naturalHeight)) : (t.setAttribute("width", t.offsetWidth), t.setAttribute("height", t.offsetHeight))), t
      }

      function n(t, e) {
        var n = t.nodeName.toLowerCase(),
          i = document.createElement("img");
        i.addEventListener("load", function () {
          "img" === n ? r(t).setAttribute("src", e) : t.style.backgroundImage = "url(" + e + ")"
        }), i.setAttribute("src", e), t.setAttribute(h, !0)
      }

      function i(t, r) {
        var i = arguments.length <= 2 || void 0 === arguments[2] ? 1 : arguments[2],
          o = e(i);
        if (r && o > 1) {
          var a = r.replace(c, "@" + o + "x$1");
          n(t, a)
        }
      }

      function o(t, e, r) {
        f > 1 && n(t, r)
      }

      function a(e) {
        return e ? "function" == typeof e.forEach ? e : t(e) : "undefined" != typeof document ? t(document.querySelectorAll(g)) : []
      }

      function u(t) {
        return t.style.backgroundImage.replace(l, "$2")
      }

      function d(t) {
        a(t).forEach(function (t) {
          if (!t.getAttribute(h)) {
            var e = "img" === t.nodeName.toLowerCase(),
              r = e ? t.getAttribute("src") : u(t),
              n = t.getAttribute("data-rjs"),
              a = !isNaN(parseInt(n, 10));
            a ? i(t, r, n) : o(t, r, n)
          }
        })
      }
      "undefined" == typeof exports && (exports = {}), Object.defineProperty(exports, "__esModule", {
        value: !0
      });
      var s = "undefined" != typeof window,
        f = s ? window.devicePixelRatio || 1 : 1,
        c = /(\.[A-z]{3,4}\/?(\?.*)?)$/,
        l = /url\(('|")?([^\)'"]+)('|")?\)/i,
        g = "[data-rjs]",
        h = "data-rjs-processed";
      s && (window.addEventListener("load", d), window.retinajs = d), exports["default"] = d
    }();

    retinajs();
  });
};

jQuery('a[href^="http"]').not('a[href^="https://' + $(location).attr('hostname') + '"]').attr('target', '_blank');

// Initialize Theme JS on docready
$(theme.init);